module.exports = __webpack_public_path__ + "img/ZizbeyJobsLogo.6dbee2ac.svg";